import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';
import {
  ActivatedRoute,
  ActivatedRouteSnapshot,
  NavigationEnd,
  Router,
} from '@angular/router';
import { distinctUntilChanged, filter } from 'rxjs/operators';
import { Breadcrumb } from '../models/breadcrumb';

@Injectable({
  providedIn: 'root',
})
export class BreadCrumbService {
  private readonly breadcrumbs = new BehaviorSubject<Breadcrumb[]>([]);
  breadcrumbs$ = this.breadcrumbs.asObservable();
  constructor(
    private readonly router: Router,
    private readonly route: ActivatedRoute
  ) {
    this.router.events
      .pipe(
        filter((event) => event instanceof NavigationEnd),
        distinctUntilChanged()
      )
      .subscribe(() => {
        this.generateBreadcrumbs();
      });

    this.generateBreadcrumbs();
  }

  private generateBreadcrumbs(): void {
    const root = this.router.routerState.snapshot.root;
    const breadcrumbs = this.createBreadcrumbs(root);
    this.breadcrumbs.next(breadcrumbs);
  }

  private createBreadcrumbs(
    route: ActivatedRouteSnapshot,
    url = '',
    breadcrumbs: Breadcrumb[] = []
  ): Breadcrumb[] {
    const children: ActivatedRouteSnapshot[] = route.children;

    if (children.length === 0) {
      return breadcrumbs;
    }

    for (const child of children) {
      const routeUrl = child.url.map((segment) => segment.path).join('/');
      if (routeUrl) {
        url += `/${routeUrl}`;
      }
      if (
        child.data['subtitle'] &&
        !this.isDuplicate(breadcrumbs, child.data['subtitle'])
      ) {
        const intermediatesData = child.data['intermediates'];
        if (intermediatesData && intermediatesData.length > 0) {
          intermediatesData.forEach((intermediate: any) => {
            breadcrumbs.push({
              label: intermediate['subtitle'],
              url: intermediate['url'],
              icon: '',
            });
          });
        }

        breadcrumbs.push({
          label: child.data['subtitle'],
          url: url,
          icon: child.data['icon'],
        });
      }

      return this.createBreadcrumbs(child, url, breadcrumbs);
    }

    return breadcrumbs;
  }

  private isDuplicate(breadcrumbs: Breadcrumb[], label: string): boolean {
    return breadcrumbs.some((breadcrumb) => breadcrumb.label === label);
  }
}
